import { useState } from 'react'
import { supabase } from '../lib/supabase'

export const useFeedback = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [submitError, setSubmitError] = useState(null)

  const submitFeedback = async (feedbackData) => {
    setIsSubmitting(true)
    setSubmitError(null)
    setSubmitSuccess(false)

    try {
      const { data, error } = await supabase
        .from('feedback')
        .insert([
          {
            care_plan_id: feedbackData.carePlanId,
            care_plan_title: feedbackData.carePlanTitle,
            feedback_type: feedbackData.type,
            user_name: feedbackData.name || null,
            user_email: feedbackData.email || null,
            comments: feedbackData.comments || null
          }
        ])

      if (error) {
        throw error
      }

      setSubmitSuccess(true)
      console.log('Feedback submitted successfully:', data)
      return { success: true, data }
    } catch (error) {
      console.error('Error submitting feedback:', error)
      setSubmitError(error.message)
      return { success: false, error: error.message }
    } finally {
      setIsSubmitting(false)
    }
  }

  const resetState = () => {
    setSubmitSuccess(false)
    setSubmitError(null)
  }

  return {
    submitFeedback,
    isSubmitting,
    submitSuccess,
    submitError,
    resetState
  }
}
